<template>
    <div class="performanceDetail">
		<div class="perform-top">
			<p class="scode-class">
				<span class="title"> {{data.serialType == 1 ? "+" : ""}}<span class="score">{{data.score}}</span>分</span>
				<span class="value max">{{data.kpiCategoryStr}}</span>
			</p>
		</div>
	    <div class="performDetail-list">
            <img class="success_status" v-if="data.appealRecord&&data.appealRecord.status == 1" src="../../assets/img/pamers/icon_success.png">
			<ul class="performDetail-list-item">
                <li class="item-detail">
                    <span class="title">流水号</span>
                    <span class="value">{{data.serialNo}}</span>
                </li>
                <li class="item-detail">
                    <span  class="title">机构信息</span>
                    <span class="value">{{data.orgName}}</span>
                </li>
                <li class="item-detail">
                    <span  class="title">关联人</span>
                    <span class="value">{{data.driverName}}</span>
                </li>
                <li class="item-detail">
                    <span  class="title">积分类型</span>
                    <span class="value">{{data.kpiTypeStr}}</span>
                </li>
                <li class="item-detail">
                    <span  class="title">积分科目</span>
                    <span class="value">{{data.kpiCategoryStr}}</span>
                </li>
                <li class="item-detail">
                    <span  class="title">变动时间</span>
                    <span class="value">{{data.createTime}}</span>
                </li>
                <li class="item-detail">
                    <span  class="title">备注</span>
                    <span class="value">{{data.remark}}</span>
                </li>
			</ul>
		</div>
        <p class="complain-box" v-if="!data.appealRecord">
            <span>对此处罚有疑问？</span>
            <span class="blur-text" @click="complainClick">点此申诉</span>
        </p>
        <p class="complain-box" v-if="data.appealRecord && data.appealRecord.status == 0">
            <span>您的申诉已提交</span>
            <span class="blur-text" @click="complainClick">点此查看</span>
        </p>
        <p class="complain-box" v-if="data.appealRecord && data.appealRecord.status == 2">
            <span>您的申诉不通过</span>
            <span class="blur-text" @click="complainClick">点此查看</span>
        </p>
    </div>
</template>

<script>
import mobileType from '../../utils/mobileType';
import util from '../../utils/util';
import {serialDetail} from '../../apis/complain/index'
export default {
    name: "performance",
    components: {
    },
    data() {
        return {
            data: {
                id: 1,
                score: 100,
                serialType: 1,
                kpiCategory: 1,
                serialNo: null,
                orgName: '',
                driverName: '',
                kpiType: 1,
                createTime: '',
                remark: '',
                appealRecord: null
            },
            appealRecord: {},
            noPassReason: '',
            status: null,
            params: {"scale":"2.0","areaCode":"110105","sysVersion":"14.7","token":"MTAxNzAwMzgyOjcwMDoyMDIzMDExNjA5NTMyODI1NzpDMUUyRTBFQy02NEM4LTQ3RUMtODU5NS1ENkY2NUEyQjZFNjQ=","appChannel":"AppStore","platform":"2","softVersion":"1.2.51","display":"1334*750","data":"{\"areaCode\":\"110105\",\"lat\":\"39.898158908420136\",\"lon\":\"116.49165907118055\",\"phone\":\"13483409446\"}","role":"2","uuidString":"7021747C-162F-46D9-8761-99AA3621013A","channel":"1020000000","cityCode":"110100","idfv":"912FD003-76D6-4DAC-B98C-4B6FFF5A00C6"},
		};
    },
    created () {
        window.getDataFromNative = this.getDataFromNative;
	},
    mounted() {
        this.getUserInfoFromApp();
        // this.getSerialDetail()

    },
    methods: {
		getUserInfoFromApp() {
			let params = {
				methodName: 'getDataFromNative',//定义与原生的方法名(固定)
				type: 1,//业务类型(固定)
			};
			if (mobileType.isIOS()) {
				//vue调用iOS方法，且传值给iOS （iOS 方法名为 getDataFromVue）
				window.webkit.messageHandlers.getDataFromVue.postMessage(params);
			} else if (mobileType.isAndroid()) {
				//vue调用Android方法，且传值给Android （Android方法名为 getDataFromVue）
				window.Android.getDataFromVue(JSON.stringify(params));
			}
		},
		getDataFromNative(params) {
			if (mobileType.isIOS()) {
				this.params = params;
			} else if (mobileType.isAndroid()) {
				this.params = JSON.parse(params);
			}
			this.getSerialDetail()
		},
        // 查询详情
		async getSerialDetail() {
            let params = {...this.params}
			params.data = JSON.stringify({
                isDj: this.$route.query.isDj,
				id: this.$route.query.id,
                driverId: this.$route.query.driverId
			})
			try {
				const res = await serialDetail(params);
				if(res.code == 1) {
					this.data = JSON.parse(res.data);
                    // this.status =
				}else {
                    this.$toast(res.msg)
                }
			} catch (error) {
				console.log(error);
			}
		},
        // 跳转申诉
        complainClick() {
            if(!this.data.appealRecord) {
                this.$router.push({
                    path: '/home/complain',
                    query: {
                        serialId: this.data.id
                    }
                })
            }
            else {
                this.$router.push({
                    path: '/home/complainResult',
                    query: {
                        serialId: this.data.appealRecord.serialId
                    }
                })
            }
        }
    }
};
</script>
<style scoped lang="less">
.performanceDetail {
	position: relative;
	width: 100%;
	background: #F2F2F2;
	height: 100%;
    .perform-top {
		background: #fff;
		background: #FFFFFF;
		box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.04);
		border-radius: 0px 0px 16px 16px;
		padding: 20px;
		padding-top: 28px;
        text-align: center;
		.scode-class {
			display: flex;
			flex-direction: column;
			.title {
				font-size: 18px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				display: inline-block;
				margin-bottom: 6px;
                .score {
                    font-size: 32px;
                    font-weight: 600;
                }
			}
			.value {
				height: 22px;
				font-size: 18px;
				font-family: PingFangSC-Semibold, PingFang SC;
				color: #333333;
				line-height: 22px;
			}
		}
	}
	.performDetail-list {
		padding: 8px 16px;
        background: #FDFEFF;
        border-radius: 8px;
        margin: 12px;
        position: relative;
        .success_status {
           width: 80px;
           height: 66px;
           position: absolute;
           right: 10px;
           top: 0;
        }
		.performDetail-list-item {
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			color: #333333;
			// padding-bottom: 16px;
            .item-detail {
                padding: 12px 0;
                border-bottom: 1px solid #E5E5E5;
                display: flex;
                font-size: 14px;
                text-align: left;
                color: #333;
                &:last-child {
                    border: 0;
                }
                span{
                    &:last-child {
                        text-align: left;
                    }
                }
                .title {
                    display: inline-block;
                    width: 100px;
                    color: #666;
                }
                .value {
                    flex:1;
                    word-break: break-all;
                    color: #333;
                }
            }
			.list-title {
				padding: 0 14px;
				height: 20px;
				font-size: 16px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 600;
				color: #666666;
				line-height: 20px;
				margin-top: 20px;
			}
		}
	}
    .complain-box {
        position: absolute;
        bottom: 44px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        width: 100%;
        display: flex;
        justify-content: center;
        .blur-text {
            color: rgba(50, 148, 242, 1)
        }
    }
}

</style>
